// extracted by mini-css-extract-plugin
export var innerPageHeader = "inner-page-header-module--innerPageHeader--7wHXb";
export var headerPattern = "inner-page-header-module--headerPattern--4w6Um";